"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonTokens = void 0;
var buttonTokens = function buttonTokens(theme) {
  return {
    font: theme.comp.button.font,
    color: {
      font: {
        high: {
          default: theme.sys.color.text.content.ondark,
          hover: theme.sys.color.text.content.ondark,
          pressed: theme.sys.color.text.content.ondark,
          focus: theme.sys.color.text.content.ondark,
          disabled: theme.sys.color.text.disabled.ondisabled
        },
        medium: {
          default: theme.sys.color.text.content.primary,
          hover: theme.sys.color.text.content.primary,
          pressed: theme.sys.color.text.content.primary,
          focus: theme.sys.color.text.content.primary,
          disabled: theme.sys.color.text.disabled.onlight
        },
        mono: {
          default: theme.sys.color.text.content.main,
          hover: theme.sys.color.text.content.main,
          pressed: theme.sys.color.text.content.main,
          focus: theme.sys.color.text.content.main,
          disabled: theme.sys.color.text.disabled.onlight
        },
        low: {
          default: theme.sys.color.text.content.primary,
          hover: theme.sys.color.text.content.primary,
          pressed: theme.sys.color.text.content.primary,
          focus: theme.sys.color.text.content.primary,
          disabled: theme.sys.color.text.disabled.onlight
        }
      },
      background: {
        high: {
          default: theme.comp.button.color.background.highemphasis.default,
          hover: theme.comp.button.color.background.highemphasis.hover,
          pressed: theme.comp.button.color.background.highemphasis.pressed,
          focus: theme.comp.button.color.background.highemphasis.default,
          disabled: theme.comp.button.color.background.highemphasis.disabled
        },
        medium: {
          default: 'transparent',
          hover: theme.comp.button.color.background.midemphasis.hover,
          pressed: theme.comp.button.color.background.midemphasis.pressed,
          focus: 'transparent',
          disabled: 'transparent'
        },
        mono: {
          default: 'transparent',
          hover: theme.comp.button.color.background.midemphasismonochrome.hover,
          pressed: theme.comp.button.color.background.midemphasismonochrome.pressed,
          focus: 'transparent',
          disabled: 'transparent'
        },
        low: {
          default: 'transparent',
          hover: theme.comp.button.color.background.midemphasis.hover,
          pressed: theme.comp.button.color.background.midemphasis.pressed,
          focus: 'transparent',
          disabled: 'transparent'
        }
      },
      icon: {
        high: {
          default: theme.sys.color.iconfill.ondark,
          hover: theme.sys.color.iconfill.ondark,
          pressed: theme.sys.color.iconfill.ondark,
          focus: theme.sys.color.iconfill.ondark,
          disabled: theme.sys.color.iconfill.ondisabled
        },
        medium: {
          default: theme.sys.color.iconfill.primary,
          hover: theme.sys.color.iconfill.primary,
          pressed: theme.sys.color.iconfill.primary,
          focus: theme.sys.color.iconfill.primary,
          disabled: theme.sys.color.iconfill.disabled
        },
        mono: {
          default: theme.sys.color.iconfill.onlight,
          hover: theme.sys.color.iconfill.onlight,
          pressed: theme.sys.color.iconfill.onlight,
          focus: theme.sys.color.iconfill.onlight,
          disabled: theme.sys.color.iconfill.disabled
        },
        low: {
          default: theme.sys.color.iconfill.primary,
          hover: theme.sys.color.iconfill.primary,
          pressed: theme.sys.color.iconfill.primary,
          focus: theme.sys.color.iconfill.primary,
          disabled: theme.sys.color.iconfill.disabled
        }
      }
    },
    border: {
      high: {
        default: '0px;',
        hover: '0px;',
        pressed: '0px;',
        focus: '0px;',
        disabled: "".concat(theme.sys.size.borderwidth.thin, " solid ").concat(theme.sys.color.border.disabled, ";")
      },
      medium: {
        default: "".concat(theme.sys.size.borderwidth.thin, " solid ").concat(theme.comp.button.color.border.midemphasis.default, ";"),
        hover: "".concat(theme.sys.size.borderwidth.thin, " solid ").concat(theme.comp.button.color.border.midemphasis.default, ";"),
        pressed: "".concat(theme.sys.size.borderwidth.thin, " solid ").concat(theme.comp.button.color.border.midemphasis.default, ";"),
        focus: "".concat(theme.sys.size.borderwidth.thin, " solid transparent;"),
        disabled: "".concat(theme.sys.size.borderwidth.thin, " solid ").concat(theme.comp.button.color.border.midemphasis.disabled, ";")
      },
      mono: {
        default: "".concat(theme.sys.size.borderwidth.thin, " solid ").concat(theme.comp.button.color.border.midemphasismonochrome.default, ";"),
        hover: "".concat(theme.sys.size.borderwidth.thin, " solid ").concat(theme.comp.button.color.border.midemphasismonochrome.hover, ";"),
        pressed: "".concat(theme.sys.size.borderwidth.thin, " solid ").concat(theme.comp.button.color.border.midemphasismonochrome.pressed, ";"),
        focus: "".concat(theme.sys.size.borderwidth.thin, " solid ").concat(theme.comp.button.color.border.midemphasismonochrome.default, ";"),
        disabled: "".concat(theme.sys.size.borderwidth.thin, " solid ").concat(theme.comp.button.color.border.midemphasismonochrome.disabled, ";")
      },
      low: {
        default: '0px;',
        hover: '0px;',
        focus: '0px;',
        disabled: '0px;'
      }
    },
    size: {
      height: '44px'
    },
    focusRing: "".concat('outline: 2px solid' + theme.sys.color.border.focusring)
  };
};
exports.buttonTokens = buttonTokens;